import { render, staticRenderFns } from "./redemptionRecord.vue?vue&type=template&id=c98aedb8&scoped=true&"
import script from "./redemptionRecord.vue?vue&type=script&lang=js&"
export * from "./redemptionRecord.vue?vue&type=script&lang=js&"
import style0 from "./redemptionRecord.vue?vue&type=style&index=0&id=c98aedb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98aedb8",
  null
  
)

export default component.exports